// extracted by mini-css-extract-plugin
module.exports = {"wrap":"not-found_wrap__1V88C","image":"not-found_image__1naMC","link":"not-found_link__1Bhi4"};